var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChevronUpDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5406 2.23017C12.3992 2.08311 12.204 2 12 2C11.796 2 11.6008 2.08311 11.4594 2.23017L5.20938 8.73017C4.92228 9.02875 4.93159 9.50353 5.23017 9.79062C5.52875 10.0777 6.00353 10.0684 6.29063 9.76983L12 3.83208L17.7094 9.76983C17.9965 10.0684 18.4713 10.0777 18.7698 9.79062C19.0684 9.50353 19.0777 9.02875 18.7906 8.73017L12.5406 2.23017ZM12.5406 21.7698C12.3992 21.9169 12.204 22 12 22C11.796 22 11.6008 21.9169 11.4594 21.7698L5.20938 15.2698C4.92228 14.9713 4.93159 14.4965 5.23017 14.2094C5.52875 13.9223 6.00353 13.9316 6.29063 14.2302L12 20.1679L17.7094 14.2302C17.9965 13.9316 18.4713 13.9223 18.7698 14.2094C19.0684 14.4965 19.0777 14.9713 18.7906 15.2698L12.5406 21.7698Z",
    fill: "#4A5256"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronUpDown);
export default __webpack_public_path__ + "static/media/icon-chevron-up-down.2fd91faa9a4f0beafd63dd6a4372c47e.svg";
export { ForwardRef as ReactComponent };